import { AccordionClass } from '@helpers/Accordion.class';

window.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll<HTMLElement>('.kf-o-accordion');

  accordions.forEach((accordion) => new AccordionClass(accordion).init());
});

export {};
